"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.makeUid = makeUid;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));
const uids = new _set.default();
function makeUid(length = 8) {
  let uid = '';
  while (uid.length < length) {
    uid += (Math.random() + 1).toString(36).replace(/[^a-z0-9]+/, '').substr(0, length - uid.length);
    if (uid.length === length && uids.has(uid)) {
      uid = '';
    }
  }
  uids.add(uid);
  return uid;
}